module.exports = __webpack_public_path__ + "mainassets/img/anim_03_570x570.589138c3.webp";